<template>
   <LoginContent>
        <router-view></router-view>
    </LoginContent>
</template>

<script>
import LoginContent from '@/components/frontend/components/LoginContent';

export default {
    components: {
        LoginContent
    }
}
</script>
